'use client';

import React from 'react';
import { useFormContext, Controller, RegisterOptions } from 'react-hook-form';
import { Checkbox } from 'src/components';

interface ControlledCheckboxProps {
  name: string;
  label?: string;
  rules?: RegisterOptions;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'outlined' | 'solid' | 'soft';
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning';
}

const ControlledCheckbox: React.FC<ControlledCheckboxProps> = ({
  name,
  label,
  rules,
  disabled = false,
  size = 'md',
  variant,
  color,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Checkbox
          {...field}
          checked={field.value || false}
          onChange={(e) => field.onChange(e.target.checked)}
          disabled={disabled}
          size={size}
          label={label}
          variant={variant}
          color={color}
        />
      )}
    />
  );
};

export default ControlledCheckbox;
